import { generatePath } from 'react-router-dom';
import { authSwitchRoutes } from '@isyc-react/auth/modules/base';
export const switchRoutes = Object.assign(Object.assign({}, authSwitchRoutes), { root: '/', bu: '/bu/:code', unlogged: '/unlogged', customAutologin: '/login-remote', dossier: {
        root: '/dossier',
        error: '/dossier/error',
        consents: '/dossier/consents',
        signatories: '/dossier/signatories',
        occupants: '/dossier/occupants',
        explications: '/dossier/explications',
        summary: '/dossier/summary',
        documents: '/dossier/documents',
        validated: '/dossier/validated',
        unknown: '/dossier/unknown',
    }, dossierWithId: {
        root: '/backoffice/:dossierId/',
        error: '/backoffice/:dossierId/error',
        consents: '/backoffice/:dossierId/consents',
        signatories: '/backoffice/:dossierId/signatories',
        occupants: '/backoffice/:dossierId/occupants',
        explications: '/backoffice/:dossierId/explications',
        summary: '/backoffice/:dossierId/summary',
        documents: '/backoffice/:dossierId/documents',
        validated: '/backoffice/:dossierId/validated',
        unknown: '/backoffice/:dossierId/unknown',
    } });
export const routes = Object.assign(Object.assign({}, switchRoutes), { bu: code => generatePath(switchRoutes.bu, { code }), dossierWithId: {
        root: dossierId => generatePath(switchRoutes.dossierWithId.root, { dossierId }),
        error: dossierId => generatePath(switchRoutes.dossierWithId.error, { dossierId }),
        consents: dossierId => generatePath(switchRoutes.dossierWithId.consents, { dossierId }),
        signatories: dossierId => generatePath(switchRoutes.dossierWithId.signatories, { dossierId }),
        occupants: dossierId => generatePath(switchRoutes.dossierWithId.occupants, { dossierId }),
        explications: dossierId => generatePath(switchRoutes.dossierWithId.explications, { dossierId }),
        summary: dossierId => generatePath(switchRoutes.dossierWithId.summary, { dossierId }),
        documents: dossierId => generatePath(switchRoutes.dossierWithId.documents, { dossierId }),
        validated: dossierId => generatePath(switchRoutes.dossierWithId.validated, { dossierId }),
        unknown: dossierId => generatePath(switchRoutes.dossierWithId.unknown, { dossierId }),
    } });
